import React from 'react';

export default (props) => {
  return (
    <div className="custom-quote">
      <p>
        Occasionally we have custom package and volume discounts. Let us help you
        decide on the best plan for your situation. Contact sales for a quote.
      </p>
      <a className="btn-link" href="https://www.papertrail.com/plans/contact/">Get Custom Quote</a>
    </div>
  );
}
